import { defaultTheme, Spinner } from "@geberit/gdds"
import { ThemeProvider as GeberitThemeProvider } from "styled-components"

const GeberitSpinner = () => {
  return (
    <GeberitThemeProvider theme={defaultTheme}>
      <Spinner />
    </GeberitThemeProvider>
  )
}

export default GeberitSpinner
